











import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

@Component({})
export default class Select61 extends Vue {
  @Prop({}) value!:string;
  @Prop() action!: string;
  @Prop() filterFunction!: Function;
  @Prop({default:"12"}) md!:string;

  isLoading = false;
  items=[];

  @Watch("action")
  onActionChange() {
    this.load();
  }

  @Watch("filterFunction")
  onFilterFunctionChange() {
    this.load();
  }

  mounted() {
    this.load();
  }

  input(value: any){
    this.$emit('input', value)
  }

  load() {
    if (this.action && this.action != "") {
      this.isLoading = true;
      this.$http.get(this.action).then((response) => {
        if (this.filterFunction) {
          this.items = this.filterFunction(response.data);
        } else {
          this.items = response.data.hasOwnProperty("data") ? response.data.data : response.data;
        }
        this.$emit("items", this.items);
      }).finally(() => (this.isLoading = false));
    }
  }
}
